<div
  class="bg-m0 min-h-[900px] flex-grow select-none flex-col overflow-y-auto p-9"
>
  <div
    data-cy="addConnectionDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Add Connection</div
  >

  <div class="flex flex-col">
    <form class="flex flex-col" [formGroup]="addForm">
      <div class="mt-9 flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0">Name</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogConnectionIdInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addForm.controls['connectionId'].invalid &&
                addForm.controls['connectionId'].touched
            }"
            formControlName="connectionId"
          />
          <m-validation
            [control]="addForm.controls['connectionId']"
          ></m-validation>
        </div>
      </div>

      <div class="mb-6 flex flex-row items-center">
        <div class="w-[200px] flex-shrink-0">Environment</div>

        <div class="flex flex-col">
          <ng-select
            #addConnectionDialogEnvSelect
            [fixNgSelectBottom]="addConnectionDialogEnvSelect"
            data-cy="addConnectionDialogEnvSelect"
            class="w-[400px] text-base"
            (open)="openEnvSelect()"
            [loading]="envsListLoading"
            [items]="envsList"
            [clearable]="false"
            [searchable]="false"
            (keyup.esc)="
              $event.stopImmediatePropagation();
              addConnectionDialogEnvSelect.blur()
            "
            (keyup.enter)="
              $event.stopImmediatePropagation();
              addConnectionDialogEnvSelect.blur()
            "
            appendTo="body"
            bindLabel="envId"
            bindValue="envId"
            formControlName="envId"
          >
            <ng-template ng-label-tmp let-item="item">
              <div class="ml-1 truncate">{{ item.envId }}</div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <div class="ml-1 truncate">{{ item.envId }}</div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="mb-6 flex flex-row items-center">
        <div class="w-[200px] flex-shrink-0">Type</div>

        <div class="flex flex-col">
          <ng-select
            #addConnectionDialogTypeSelect
            [fixNgSelectBottom]="addConnectionDialogTypeSelect"
            data-cy="addConnectionDialogTypeSelect"
            class="connection-type-select w-[400px] text-base"
            [items]="connectionTypes"
            [clearable]="false"
            [searchable]="false"
            (change)="changeType($event)"
            (keyup.esc)="
              $event.stopImmediatePropagation();
              addConnectionDialogTypeSelect.blur()
            "
            (keyup.enter)="
              $event.stopImmediatePropagation();
              addConnectionDialogTypeSelect.blur()
            "
            appendTo="body"
            formControlName="type"
          >
            <ng-template ng-label-tmp let-item="item">
              <div class="ml-1 truncate">{{ item }}</div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <div class="ml-1 truncate">{{ item }}</div>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="addBigqueryForm"
      *ngIf="addForm.controls['type'].value === typeBigQuery"
    >
      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
          >Service Account Credentials</div
        >

        <div class="flex flex-col">
          <textarea
            rows="7"
            data-cy="addConnectionDialogBigqueryServiceAccountCredentialsInput"
            class="form-input border-s3 focus:border-m600 w-[400px] resize-none whitespace-nowrap rounded font-mono"
            [ngClass]="{
              'border-r600':
                addBigqueryForm.controls['serviceAccountCredentials'].invalid &&
                addBigqueryForm.controls['serviceAccountCredentials'].touched
            }"
            formControlName="serviceAccountCredentials"
            placeholder="JSON"
          ></textarea>
          <m-validation
            [control]="addBigqueryForm.controls['serviceAccountCredentials']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
          >Query Size Limit, gb</div
        >

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogBigqueryQuerySizeLimitGbInput"
            class="form-input border-s3 focus:border-m600 w-80 rounded"
            [ngClass]="{
              'border-r600':
                addBigqueryForm.controls['bigqueryQuerySizeLimitGb'].invalid &&
                addBigqueryForm.controls['bigqueryQuerySizeLimitGb'].touched
            }"
            formControlName="bigqueryQuerySizeLimitGb"
            placeholder="Query Size Limit, gb (default: 1)"
          />
          <m-validation
            [control]="addBigqueryForm.controls['bigqueryQuerySizeLimitGb']"
          ></m-validation>
        </div>
      </div>
    </form>

    <!-- <form
      class="flex w-80 flex-col text-base"
      [formGroup]="addClickhouseForm"
      *ngIf="addForm.controls['type'].value === typeClickHouse"
    >
      <div>
        <div class="mb-6 flex flex-row items-center">
          <div class="w-[200px] flex-shrink-0 font-semibold">HTTPS</div>

          <div class="flex flex-col">
            <div
              class="flex max-w-min cursor-pointer flex-row items-center"
              (click)="toggleClickhouseSSL()"
            >
              <ui-switch
                class=""
                [checked]="isClickhouseSSL"
                color="#64BD63"
              ></ui-switch>
            </div>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Host</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogClickhouseHostInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  addClickhouseForm.controls['host'].invalid &&
                  addClickhouseForm.controls['host'].touched
              }"
              formControlName="host"
            />
            <m-validation
              [control]="addClickhouseForm.controls['host']"
            ></m-validation>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Port</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogClickhousePortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  addClickhouseForm.controls['port'].invalid &&
                  addClickhouseForm.controls['port'].touched
              }"
              formControlName="port"
            />
            <m-validation
              [control]="addClickhouseForm.controls['port']"
            ></m-validation>
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">User</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogClickhouseUserInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addClickhouseForm.controls['username'].invalid &&
                addClickhouseForm.controls['username'].touched
            }"
            formControlName="username"
          />
          <m-validation
            [control]="addClickhouseForm.controls['username']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Password</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogClickhousePasswordInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addClickhouseForm.controls['password'].invalid &&
                addClickhouseForm.controls['password'].touched
            }"
            formControlName="password"
            type="password"
          />
          <m-validation
            [control]="addClickhouseForm.controls['password']"
          ></m-validation>
        </div>
      </div>
    </form> -->

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="addMotherduckForm"
      *ngIf="addForm.controls['type'].value === typeMotherDuck"
    >
      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
          >MotherDuck Token</div
        >

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogMotherduckTokenInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addMotherduckForm.controls['motherduckToken'].invalid &&
                addMotherduckForm.controls['motherduckToken'].touched
            }"
            formControlName="motherduckToken"
          />
          <m-validation
            [control]="addMotherduckForm.controls['motherduckToken']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-start">
        <div class="mb-6 mt-3 w-[200px] flex-shrink-0 font-semibold"
          >Database</div
        >

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogMotherduckDatabaseInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addMotherduckForm.controls['database'].invalid &&
                addMotherduckForm.controls['database'].touched
            }"
            formControlName="database"
            placeholder="Optional"
          />
          <m-validation
            [control]="addMotherduckForm.controls['database']"
          ></m-validation>

          <div class="text-s400 mb-5 mt-2 h-[50px] text-base"
            >md:{{ addMotherduckForm.controls['database'].value }}?{{
              isMotherduckAttachModeSingle === true
                ? addMotherduckForm.controls['database'].value?.length > 0
                  ? 'attach_mode=single&'
                  : ''
                : ''
            }}saas_mode:true</div
          >
        </div>
      </div>

      <div
        class="mb-6 flex flex-row items-center"
        *ngIf="addMotherduckForm.controls['database'].value?.length > 0"
      >
        <div class="w-[200px] flex-shrink-0 font-semibold"
          >Attach Mode "single"</div
        >

        <div class="flex flex-col">
          <div
            class="flex max-w-min cursor-pointer flex-row items-center"
            (click)="toggleMotherduckAttachModeSingle()"
          >
            <ui-switch
              class=""
              [checked]="isMotherduckAttachModeSingle"
              color="#64BD63"
            ></ui-switch>
          </div>
        </div>
      </div>

      <div class="mb-6 flex flex-row items-center">
        <div class="w-[200px] flex-shrink-0 font-semibold"
          >Access Mode "READ_ONLY"</div
        >

        <div class="flex flex-col">
          <div
            class="flex max-w-min cursor-pointer flex-row items-center"
            (click)="toggleMotherduckAccessModeReadOnly()"
          >
            <ui-switch
              class=""
              [checked]="isMotherduckAccessModeReadOnly"
              color="#64BD63"
            ></ui-switch>
          </div>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="addPostgresForm"
      *ngIf="addForm.controls['type'].value === typePostgreSQL"
    >
      <div>
        <div class="mb-6 flex flex-row items-center">
          <div class="w-[200px] flex-shrink-0 font-semibold">SSL</div>

          <div class="flex flex-col">
            <div
              class="flex max-w-min cursor-pointer flex-row items-center"
              (click)="togglePostgresSSL()"
            >
              <ui-switch
                class=""
                [checked]="isPostgresSSL"
                color="#64BD63"
              ></ui-switch>
            </div>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Host</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogPostgresHostInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  addPostgresForm.controls['host'].invalid &&
                  addPostgresForm.controls['host'].touched
              }"
              formControlName="host"
            />
            <m-validation
              [control]="addPostgresForm.controls['host']"
            ></m-validation>
          </div>
        </div>

        <div class="mb-6 flex flex-row items-center">
          <div class="w-[200px] flex-shrink-0 font-semibold">Internal Host</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogPostgresInternalHostInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalHost"
              placeholder="Optional"
            />
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Port</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogPostgresPortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  addPostgresForm.controls['port'].invalid &&
                  addPostgresForm.controls['port'].touched
              }"
              formControlName="port"
            />
            <m-validation
              [control]="addPostgresForm.controls['port']"
            ></m-validation>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
            >Internal Port</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogPostgresInternalPortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalPort"
              placeholder="Optional"
            />
            <m-validation
              [control]="addPostgresForm.controls['internalPort']"
            ></m-validation>
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Database</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogPostgresDatabaseInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addPostgresForm.controls['database'].invalid &&
                addPostgresForm.controls['database'].touched
            }"
            formControlName="database"
          />
          <m-validation
            [control]="addPostgresForm.controls['database']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">User</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogPostgresUserInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addPostgresForm.controls['username'].invalid &&
                addPostgresForm.controls['username'].touched
            }"
            formControlName="username"
          />
          <m-validation
            [control]="addPostgresForm.controls['username']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Password</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogPostgresPasswordInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addPostgresForm.controls['password'].invalid &&
                addPostgresForm.controls['password'].touched
            }"
            formControlName="password"
            type="password"
          />
          <m-validation
            [control]="addPostgresForm.controls['password']"
          ></m-validation>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="addMysqlForm"
      *ngIf="addForm.controls['type'].value === typeMySQL"
    >
      <div>
        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Host</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogMysqlHostInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  addMysqlForm.controls['host'].invalid &&
                  addMysqlForm.controls['host'].touched
              }"
              formControlName="host"
            />
            <m-validation
              [control]="addMysqlForm.controls['host']"
            ></m-validation>
          </div>
        </div>

        <div class="mb-6 flex flex-row items-center">
          <div class="w-[200px] flex-shrink-0 font-semibold">Internal Host</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogMysqlInternalHostInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalHost"
              placeholder="Optional"
            />
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Port</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogMysqlPortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  addMysqlForm.controls['port'].invalid &&
                  addMysqlForm.controls['port'].touched
              }"
              formControlName="port"
            />
            <m-validation
              [control]="addMysqlForm.controls['port']"
            ></m-validation>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
            >Internal Port</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogMysqlInternalPortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalPort"
              placeholder="Optional"
            />
            <m-validation
              [control]="addMysqlForm.controls['internalPort']"
            ></m-validation>
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Database</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogMysqlDatabaseInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addMysqlForm.controls['database'].invalid &&
                addMysqlForm.controls['database'].touched
            }"
            formControlName="database"
          />
          <m-validation
            [control]="addMysqlForm.controls['database']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">User</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogMysqlUserInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addMysqlForm.controls['user'].invalid &&
                addMysqlForm.controls['user'].touched
            }"
            formControlName="user"
          />
          <m-validation
            [control]="addMysqlForm.controls['user']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Password</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogMysqlPasswordInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addMysqlForm.controls['password'].invalid &&
                addMysqlForm.controls['password'].touched
            }"
            formControlName="password"
            type="password"
          />
          <m-validation
            [control]="addMysqlForm.controls['password']"
          ></m-validation>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="addTrinoForm"
      *ngIf="addForm.controls['type'].value === typeTrino"
    >
      <div>
        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Server</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogTrinoServerInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  addTrinoForm.controls['server'].invalid &&
                  addTrinoForm.controls['server'].touched
              }"
              formControlName="server"
              placeholder="http(s)://hostname:port"
            />
            <m-validation
              [control]="addTrinoForm.controls['server']"
            ></m-validation>
          </div>
        </div>

        <div class="mb-6 flex flex-row items-center">
          <div class="w-[200px] flex-shrink-0 font-semibold"
            >Internal Server</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogTrinoInternalServerInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalServer"
              placeholder="Optional"
            />
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Catalog</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogTrinoCatalogInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addTrinoForm.controls['catalog'].invalid &&
                addTrinoForm.controls['catalog'].touched
            }"
            formControlName="catalog"
          />
          <m-validation
            [control]="addTrinoForm.controls['catalog']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Schema</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogTrinoSchemaInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addTrinoForm.controls['schema'].invalid &&
                addTrinoForm.controls['schema'].touched
            }"
            formControlName="schema"
          />
          <m-validation
            [control]="addTrinoForm.controls['schema']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">User</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogTrinoUserInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addTrinoForm.controls['user'].invalid &&
                addTrinoForm.controls['user'].touched
            }"
            formControlName="user"
          />
          <m-validation
            [control]="addTrinoForm.controls['user']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Password</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogTrinoPasswordInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addTrinoForm.controls['password'].invalid &&
                addTrinoForm.controls['password'].touched
            }"
            formControlName="password"
            type="password"
          />
          <m-validation
            [control]="addTrinoForm.controls['password']"
          ></m-validation>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="addPrestoForm"
      *ngIf="addForm.controls['type'].value === typePresto"
    >
      <div>
        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Server</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogPrestoServerInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  addPrestoForm.controls['server'].invalid &&
                  addPrestoForm.controls['server'].touched
              }"
              formControlName="server"
              placeholder="http(s)://hostname"
            />
            <m-validation
              [control]="addPrestoForm.controls['server']"
            ></m-validation>
          </div>
        </div>

        <div class="mb-6 flex flex-row items-center">
          <div class="w-[200px] flex-shrink-0 font-semibold"
            >Internal Server</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogPrestoInternalServerInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalServer"
              placeholder="Optional"
            />
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Port</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogPrestoPortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  addPrestoForm.controls['port'].invalid &&
                  addPrestoForm.controls['port'].touched
              }"
              formControlName="port"
            />
            <m-validation
              [control]="addPrestoForm.controls['port']"
            ></m-validation>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
            >Internal Port</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogPrestoInternalPortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalPort"
              placeholder="Optional"
            />
            <m-validation
              [control]="addPrestoForm.controls['internalPort']"
            ></m-validation>
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Catalog</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogPrestoCatalogInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addPrestoForm.controls['catalog'].invalid &&
                addPrestoForm.controls['catalog'].touched
            }"
            formControlName="catalog"
          />
          <m-validation
            [control]="addPrestoForm.controls['catalog']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Schema</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogPrestoSchemaInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addPrestoForm.controls['schema'].invalid &&
                addPrestoForm.controls['schema'].touched
            }"
            formControlName="schema"
          />
          <m-validation
            [control]="addPrestoForm.controls['schema']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">User</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogPrestoUserInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addPrestoForm.controls['user'].invalid &&
                addPrestoForm.controls['user'].touched
            }"
            formControlName="user"
          />
          <m-validation
            [control]="addPrestoForm.controls['user']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Password</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogPrestoPasswordInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addPrestoForm.controls['password'].invalid &&
                addPrestoForm.controls['password'].touched
            }"
            formControlName="password"
            type="password"
          />
          <m-validation
            [control]="addPrestoForm.controls['password']"
          ></m-validation>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="addSnowflakeForm"
      *ngIf="addForm.controls['type'].value === typeSnowFlake"
    >
      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Account</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogSnowflakeAccountInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addSnowflakeForm.controls['account'].invalid &&
                addSnowflakeForm.controls['account'].touched
            }"
            formControlName="account"
          />
          <m-validation
            [control]="addSnowflakeForm.controls['account']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Warehouse</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogSnowflakeWarehouseInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addSnowflakeForm.controls['warehouse'].invalid &&
                addSnowflakeForm.controls['warehouse'].touched
            }"
            formControlName="warehouse"
          />
          <m-validation
            [control]="addSnowflakeForm.controls['warehouse']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Database</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogSnowflakeDatabaseInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addSnowflakeForm.controls['database'].invalid &&
                addSnowflakeForm.controls['database'].touched
            }"
            formControlName="database"
            placeholder="Optional"
          />
          <m-validation
            [control]="addSnowflakeForm.controls['database']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">User</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogSnowflakeUserInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addSnowflakeForm.controls['username'].invalid &&
                addSnowflakeForm.controls['username'].touched
            }"
            formControlName="username"
          />
          <m-validation
            [control]="addSnowflakeForm.controls['username']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Password</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogSnowflakePasswordInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addSnowflakeForm.controls['password'].invalid &&
                addSnowflakeForm.controls['password'].touched
            }"
            formControlName="password"
            type="password"
          />
          <m-validation
            [control]="addSnowflakeForm.controls['password']"
          ></m-validation>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="addDatabricksForm"
      *ngIf="addForm.controls['type'].value === typeDatabricks"
    >
      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Host</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogDatabricksHostInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addDatabricksForm.controls['host'].invalid &&
                addDatabricksForm.controls['host'].touched
            }"
            formControlName="host"
          />
          <m-validation
            [control]="addDatabricksForm.controls['host']"
          ></m-validation>
        </div>
      </div>

      <div class="mb-6 flex flex-row items-center">
        <div class="w-[200px] flex-shrink-0 font-semibold">Internal Host</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogDatabricksInternalHostInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            formControlName="internalHost"
            placeholder="Optional"
          />
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">HTTP Path</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogDatabricksPathInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addDatabricksForm.controls['path'].invalid &&
                addDatabricksForm.controls['path'].touched
            }"
            formControlName="path"
          />
          <m-validation
            [control]="addDatabricksForm.controls['path']"
          ></m-validation>
        </div>
      </div>

      <div class="mb-6 flex flex-row items-center">
        <div class="w-[200px] flex-shrink-0 font-semibold">Auth Type</div>

        <div class="flex flex-col">
          <ng-select
            #addConnectionDialogDatabricksAuthTypeSelect
            [fixNgSelectBottom]="addConnectionDialogDatabricksAuthTypeSelect"
            data-cy="addConnectionDialogDatabricksAuthTypeSelect"
            class="w-[400px] text-base"
            [items]="databricksAuthTypes"
            [clearable]="false"
            [searchable]="false"
            appendTo="body"
            formControlName="authType"
          ></ng-select>
        </div>
      </div>

      <ng-container
        *ngIf="
          addDatabricksForm.controls['authType'].value ===
          databricksAuthTypeOAuthM2M
        "
      >
        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
            >OAuth Client ID</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogDatabricksOauthClientIdInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  addDatabricksForm.controls['oauthClientId'].invalid &&
                  addDatabricksForm.controls['oauthClientId'].touched
              }"
              formControlName="oauthClientId"
            />
            <m-validation
              [control]="addDatabricksForm.controls['oauthClientId']"
            ></m-validation>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
            >OAuth Client Secret</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="addConnectionDialogDatabricksOauthClientSecretInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  addDatabricksForm.controls['oauthClientSecret'].invalid &&
                  addDatabricksForm.controls['oauthClientSecret'].touched
              }"
              formControlName="oauthClientSecret"
              type="password"
            />
            <m-validation
              [control]="addDatabricksForm.controls['oauthClientSecret']"
            ></m-validation>
          </div>
        </div>
      </ng-container>

      <div
        class="flex flex-row items-center"
        *ngIf="
          addDatabricksForm.controls['authType'].value === databricksAuthTypePAT
        "
      >
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Token</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogDatabricksTokenInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addDatabricksForm.controls['token'].invalid &&
                addDatabricksForm.controls['token'].touched
            }"
            formControlName="token"
            type="password"
          />
          <m-validation
            [control]="addDatabricksForm.controls['token']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
          >Default Catalog</div
        >

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogDatabricksDefaultCatalogInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addDatabricksForm.controls['defaultCatalog'].invalid &&
                addDatabricksForm.controls['defaultCatalog'].touched
            }"
            formControlName="defaultCatalog"
            placeholder="Optional"
          />
          <m-validation
            [control]="addDatabricksForm.controls['defaultCatalog']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
          >Default Schema</div
        >

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogDatabricksDefaultSchemaInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addDatabricksForm.controls['defaultSchema'].invalid &&
                addDatabricksForm.controls['defaultSchema'].touched
            }"
            formControlName="defaultSchema"
            placeholder="Optional"
          />
          <m-validation
            [control]="addDatabricksForm.controls['defaultSchema']"
          ></m-validation>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="addApiForm"
      *ngIf="addForm.controls['type'].value === typeApi"
    >
      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Base URL</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogApiBaseUrlInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addApiForm.controls['baseUrl'].invalid &&
                addApiForm.controls['baseUrl'].touched
            }"
            formControlName="baseUrl"
            placeholder="https://example.com"
          />

          <m-validation
            [control]="addApiForm.controls['baseUrl']"
          ></m-validation>
        </div>
      </div>

      <div>
        <div class="mb-6 flex flex-row items-center">
          <div class="flex w-[200px] flex-shrink-0 font-semibold">Headers</div>
        </div>

        <div formArrayName="headers">
          <div class="flex flex-col">
            <div *ngFor="let header of apiGetHeaders().controls; let i = index">
              <div
                [formGroupName]="i"
                class="mb-6 flex w-[700px] flex-row items-center"
              >
                <button
                  class="text-s500 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  (click)="apiRemoveHeader(i)"
                >
                  <m-trash-icon></m-trash-icon>
                </button>

                <div class="ml-5 select-none">Key</div>

                <input
                  class="form-input border-s3 focus:border-m600 ml-5 w-[160px] rounded"
                  autocomplete="off"
                  spellcheck="false"
                  data-cy="addConnectionApiHeaderKeyInput"
                  formControlName="key"
                />

                <div class="ml-5 select-none">Value</div>

                <input
                  class="form-input border-s3 focus:border-m600 ml-5 w-full rounded"
                  autocomplete="off"
                  spellcheck="false"
                  data-cy="addConnectionApiHeaderValueInput"
                  formControlName="value"
                  placeholder="Will be empty after Save if not set"
                />
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          data-cy="addConnectionDialogApiAddHeaderButton"
          class="border-s400 text-s500 hover:bg-s100 h-11 flex-shrink-0 rounded border px-4 text-base leading-3 shadow-sm focus:outline-none"
          (click)="apiAddHeader()"
          >Add Header</button
        >
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="addGoogleApiForm"
      *ngIf="addForm.controls['type'].value === typeGoogleApi"
    >
      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
          >Service Account Credentials</div
        >

        <div class="flex flex-col">
          <textarea
            rows="7"
            data-cy="addConnectionDialogGoogleApiServiceAccountCredentialsInput"
            class="form-input border-s3 focus:border-m600 w-[400px] resize-none whitespace-nowrap rounded font-mono"
            [ngClass]="{
              'border-r600':
                addGoogleApiForm.controls['serviceAccountCredentials']
                  .invalid &&
                addGoogleApiForm.controls['serviceAccountCredentials'].touched
            }"
            formControlName="serviceAccountCredentials"
            placeholder="JSON"
          ></textarea>

          <m-validation
            [control]="addGoogleApiForm.controls['serviceAccountCredentials']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Base URL</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="addConnectionDialogGoogleApiBaseUrlInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                addGoogleApiForm.controls['baseUrl'].invalid &&
                addGoogleApiForm.controls['baseUrl'].touched
            }"
            formControlName="baseUrl"
            placeholder="https://analyticsdata.googleapis.com"
          />

          <m-validation
            [control]="addGoogleApiForm.controls['baseUrl']"
          ></m-validation>
        </div>
      </div>

      <div>
        <div class="mb-6 flex flex-row items-center">
          <div class="flex w-[200px] flex-shrink-0 font-semibold">Scopes</div>
        </div>

        <div formArrayName="scopes">
          <div class="flex flex-col">
            <div *ngFor="let scopes of getScopes().controls; let i = index">
              <div
                [formGroupName]="i"
                class="mb-6 flex w-[700px] flex-row items-center"
              >
                <button
                  class="text-s500 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  (click)="removeScope(i)"
                >
                  <m-trash-icon></m-trash-icon>
                </button>

                <div class="ml-5 select-none">Scope</div>

                <input
                  class="form-input border-s3 focus:border-m600 ml-5 w-full rounded"
                  autocomplete="off"
                  spellcheck="false"
                  data-cy="addConnectionDialogGoogleApiScope"
                  formControlName="value"
                  placeholder="https://www.googleapis.com/auth/analytics.readonly"
                />
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          data-cy="addConnectionDialogGoogleApiAddScopeButton"
          class="border-s400 text-s500 hover:bg-s100 h-11 flex-shrink-0 rounded border px-4 text-base leading-3 shadow-sm focus:outline-none"
          (click)="addScope()"
          >Add Scope</button
        >
      </div>

      <div>
        <div class="mb-6 mt-6 flex flex-row items-center">
          <div class="flex w-[200px] flex-shrink-0 font-semibold">Headers</div>
        </div>

        <div class="text-s400 mb-6 w-[628px]"
          >No need to add more headers for this connection type. Authorization
          (Bearer token) and Content-Type (application/json) headers will be
          auto added. Authorization token will be obtained using the Service
          Account Credentials.
        </div>

        <div formArrayName="headers">
          <div class="flex flex-col">
            <div
              *ngFor="
                let header of googleApiGetHeaders().controls;
                let i = index
              "
            >
              <div
                [formGroupName]="i"
                class="mb-6 flex w-[700px] flex-row items-center"
              >
                <button
                  class="text-s500 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  (click)="googleApiRemoveHeader(i)"
                >
                  <m-trash-icon></m-trash-icon>
                </button>

                <div class="ml-5 select-none">Key</div>

                <input
                  class="form-input border-s3 focus:border-m600 ml-5 w-[160px] rounded"
                  autocomplete="off"
                  spellcheck="false"
                  data-cy="addConnectionDialogGoogleApiHeaderKeyInput"
                  formControlName="key"
                />

                <div class="ml-5 select-none">Value</div>

                <input
                  class="form-input border-s3 focus:border-m600 ml-5 w-full rounded"
                  autocomplete="off"
                  spellcheck="false"
                  data-cy="addConnectionDialogGoogleApiHeaderValueInput"
                  formControlName="value"
                  placeholder="Will be empty after Save if not set"
                />
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          data-cy="addConnectionDialogGoogleApiAddHeaderButton"
          class="border-s400 text-s500 hover:bg-s100 h-11 flex-shrink-0 rounded border px-4 text-base leading-3 shadow-sm focus:outline-none"
          (click)="googleApiAddHeader()"
          >Add Header</button
        >
      </div>
    </form>

    <div class="mt-9 flex flex-row items-start">
      <button
        data-cy="addConnectionDialogAddButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="add()"
        >Add</button
      >

      <button
        data-cy="addConnectionDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >

      <div class="flex flex-1"></div>

      <div
        *ngIf="
          addForm.controls['type'].value !== typeGoogleApi &&
          addForm.controls['type'].value !== typeApi
        "
        class="ml-5 flex flex-shrink-0 flex-col items-end gap-2"
      >
        <div class="flex h-[50px] flex-row items-center">
          <div
            *ngIf="testConnectionResult?.isSuccess === true"
            class="flex flex-shrink-0 items-center px-3 font-semibold text-green-600"
          >
            Connection is valid
          </div>

          <div
            *ngIf="testConnectionResult?.isSuccess === false"
            class="flex flex-shrink-0 items-center px-3 font-semibold text-red-500"
            [tp]="errorMessageTemplate"
          >
            Connection failed
          </div>

          <ng-template #errorMessageTemplate>
            <div class="break-words">{{
              !!testConnectionResult?.errorMessage
                ? testConnectionResult?.errorMessage
                : 'Error message is empty'
            }}</div>
          </ng-template>

          <button
            data-cy="addConnectionDialogTestConnectionButton"
            class="bg-m600 text-m0 ml-3 w-60 rounded py-3 text-base font-medium focus:outline-none"
            type="button"
            (click)="testConnection()"
            >Test Connection</button
          >
        </div>

        <div class="flex h-[50px] flex-row items-center">
          <div
            *ngIf="testInternalHostResult?.isSuccess === true"
            class="flex flex-shrink-0 items-center px-3 font-semibold text-green-600"
          >
            Internal is valid
          </div>

          <div
            *ngIf="testInternalHostResult?.isSuccess === false"
            class="flex flex-shrink-0 items-center px-3 font-semibold text-red-500"
            [tp]="internalErrorMessageTemplate"
          >
            Internal failed
          </div>

          <ng-template #internalErrorMessageTemplate>
            <div class="break-words">{{
              !!testInternalHostResult?.errorMessage
                ? testInternalHostResult?.errorMessage
                : 'Error message is empty'
            }}</div>
          </ng-template>

          <button
            data-cy="addConnectionDialogTestInternalHostButton"
            class="text-m0 ml-3 w-60 rounded py-3 text-base font-medium focus:outline-none"
            [ngClass]="
              isInternalFieldsComplete() ? 'bg-m600' : 'bg-s400 cursor-default'
            "
            type="button"
            [disabled]="!isInternalFieldsComplete()"
            (click)="testInternalHost()"
            >Test Internal Connection</button
          >
        </div>
      </div>
    </div>

    <div class="mt-2 flex h-6 flex-row items-center justify-end">
      <div
        *ngIf="isCurrentInternalPairInvalid()"
        class="text-sm font-semibold text-red-500"
      >
        {{ getInternalPairErrorMessage() }}
      </div>
    </div>
  </div>
</div>
